// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionOption_wrapper__fp2BJ","active":"QuestionOption_active__2KAIS","correct":"QuestionOption_correct__1C05X","incorrect":"QuestionOption_incorrect__3lhTg"};